/**
 * Adds a startWith with an empty array of the right type.
 */

import type * as Rx from 'rxjs';
import { startWith } from 'rxjs/operators';

export function startWithEmptyList<T>(): (
  source$: Rx.Observable<readonly T[]>,
) => Rx.Observable<readonly T[]> {
  return startWith([] as readonly T[]);
}
